/* Cosmova – product page: gallery rail & thumbnails, lightbox zoom, video stories, sticky buy bar,
   bundle (frequently bought together), back-in-stock form, complementary products. Requires theme.js. */
(function () {
  'use strict';
  var C = window.Cosmova; if (!C) return;
  var qs = C.qs, qsa = C.qsa, on = C.on;

  function initGallery(sec) {
    var rail = qs('[data-gallery-rail]', sec), gallery = qs('[data-gallery]', sec);
    if (rail && gallery) {
      var updateRail = function () {
        var r = gallery.getBoundingClientRect(), vh = window.innerHeight;
        var total = Math.max(1, r.height - vh);
        var p = Math.min(1, Math.max(0, -r.top / total));
        var h = Math.min(100, vh / Math.max(1, r.height) * 100);
        rail.style.setProperty('--rail-h', h + '%');
        rail.style.setProperty('--rail-top', (p * (100 - h)) + '%');
      };
      on(window, 'scroll', updateRail, { passive: true }); updateRail();
      on(qs('[data-rail-up]', rail), 'click', function () { window.scrollBy({ top: -window.innerHeight * 0.8, behavior: C.reduceMotion ? 'auto' : 'smooth' }); });
      on(qs('[data-rail-down]', rail), 'click', function () { window.scrollBy({ top: window.innerHeight * 0.8, behavior: C.reduceMotion ? 'auto' : 'smooth' }); });
    }
    var thumbs = qs('[data-gallery-thumbs]', sec);
    if (thumbs && gallery) {
      var tb = qsa('[data-thumb-index]', thumbs);
      tb.forEach(function (b) { on(b, 'click', function () { var it = gallery.children[+b.getAttribute('data-thumb-index')]; if (it) gallery.scrollTo({ left: it.offsetLeft - gallery.offsetLeft, behavior: 'smooth' }); }); });
      on(gallery, 'scroll', C.debounce(function () { var i = Math.round(gallery.scrollLeft / Math.max(1, gallery.clientWidth)); tb.forEach(function (b, n) { b.classList.toggle('is-active', n === i); b.setAttribute('aria-current', String(n === i)); }); }, 50), { passive: true });
    }
  }

  /* Lightbox: full-screen slides, click/tap to zoom 2.2x and pan with pointer, arrows + keyboard */
  function initLightbox(sec) {
    var box = qs('[data-lightbox]', sec); if (!box) return;
    document.body.appendChild(box);
    box.classList.add('modal'); box.tabIndex = -1;
    var track = qs('[data-lightbox-track]', box), slides = qsa('.lightbox__slide', box), counter = qs('[data-lightbox-counter]', box), index = 0;
    function go(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); s.classList.remove('is-zoomed'); s.style.removeProperty('--zx'); s.style.removeProperty('--zy'); });
      track.scrollTo({ left: slides[index].offsetLeft, behavior: 'auto' });
      if (counter) counter.textContent = (index + 1) + ' / ' + slides.length;
    }
    on(sec, 'click', function (e) {
      var zoomBtn = e.target.closest('[data-lightbox-open]');
      var fig = !zoomBtn && e.target.closest('[data-lightbox-index]');
      if (!zoomBtn && !fig) return;
      if (fig && e.target.closest('a, button, video')) return;
      var t = zoomBtn || fig;
      e.preventDefault();
      C.open(box, { returnFocus: t.matches('button') ? t : qs('.gallery__zoom', t) });
      var n = parseInt(t.getAttribute('data-lightbox-open') || t.getAttribute('data-lightbox-index'), 10) || 0;
      requestAnimationFrame(function () { go(n); });
    });
    on(qs('[data-lightbox-prev]', box), 'click', function () { go(index - 1); });
    on(qs('[data-lightbox-next]', box), 'click', function () { go(index + 1); });
    on(qs('[data-lightbox-close]', box), 'click', function () { C.close(box); });
    on(box, 'keydown', function (e) { if (e.key === 'ArrowRight') go(index + 1); if (e.key === 'ArrowLeft') go(index - 1); });
    slides.forEach(function (s) {
      on(s, 'click', function (e) {
        var zoomed = s.classList.toggle('is-zoomed');
        if (zoomed) pan(s, e);
      });
      on(s, 'pointermove', function (e) { if (s.classList.contains('is-zoomed')) pan(s, e); });
    });
    function pan(s, e) { var r = s.getBoundingClientRect(); s.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%'); s.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%'); }
    on(track, 'scroll', C.debounce(function () { var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); if (i !== index && slides[i]) { index = i; if (counter) counter.textContent = (index + 1) + ' / ' + slides.length; } }, 80), { passive: true });
  }

  /* Video stories: circles open a coverflow modal; play/pause, mute, arrows, swipe, keyboard */
  function initStories(sec) {
    qsa('[data-stories]', sec).forEach(function (wrap) {
      var modal = qs('[data-stories-modal]', wrap); if (!modal) return;
      document.body.appendChild(modal);
      modal.classList.add('modal'); modal.tabIndex = -1;
      var stories = qsa('[data-story]', modal), index = 0, playing = true, muted = true;
      var playBtn = qs('[data-stories-play]', modal), muteBtn = qs('[data-stories-mute]', modal);
      function videoOf(s) { return qs('video', s); }
      function layout() {
        stories.forEach(function (s, n) {
          var off = n - index;
          s.style.setProperty('--off', off); s.style.setProperty('--abs', Math.abs(off));
          s.classList.toggle('is-active', off === 0);
          s.setAttribute('aria-hidden', String(off !== 0));
          var v = videoOf(s); if (!v) return;
          if (off === 0) { v.muted = muted; if (playing) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } } else v.pause();
        });
      }
      function go(i) { index = Math.max(0, Math.min(stories.length - 1, i)); layout(); }
      on(wrap, 'click', function (e) { var c = e.target.closest('[data-story-index]'); if (!c) return; C.open(modal, { returnFocus: c }); go(parseInt(c.getAttribute('data-story-index'), 10) || 0); });
      on(qs('[data-stories-prev]', modal), 'click', function () { go(index - 1); });
      on(qs('[data-stories-next]', modal), 'click', function () { go(index + 1); });
      on(qs('[data-stories-close]', modal), 'click', function () { C.close(modal); });
      on(modal, 'click', function (e) { var s = e.target.closest('[data-story]'); if (s && !s.classList.contains('is-active')) go(stories.indexOf(s)); });
      on(modal, 'keydown', function (e) { if (e.key === 'ArrowRight') go(index + 1); if (e.key === 'ArrowLeft') go(index - 1); });
      on(playBtn, 'click', function () { playing = !playing; playBtn.setAttribute('aria-pressed', String(playing)); playBtn.setAttribute('aria-label', playBtn.getAttribute(playing ? 'data-label-pause' : 'data-label-play')); layout(); var v = videoOf(stories[index]); if (v && !playing) v.pause(); });
      on(muteBtn, 'click', function () { muted = !muted; muteBtn.setAttribute('aria-pressed', String(muted)); layout(); });
      var x0 = null;
      on(modal, 'touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      on(modal, 'touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1)); x0 = null; });
      on(modal, 'layer:close', function () { stories.forEach(function (s) { var v = videoOf(s); if (v) v.pause(); }); });
      layout();
    });
  }

  /* Sticky buy bar: appears once the main buy buttons scroll out of view */
  function initSticky(sec) {
    var bar = qs('[data-sticky-atc]', sec), form = qs('form.product-form', sec);
    if (!bar || !form || !('IntersectionObserver' in window)) return;
    var footer = qs('.section-footer, footer');
    var formOut = false, footerIn = false;
    function setH() { document.documentElement.style.setProperty('--sticky-atc-h', bar.offsetHeight + 'px'); }
    if ('ResizeObserver' in window) new ResizeObserver(function () { if (bar.classList.contains('is-visible')) setH(); }).observe(bar);
    function apply() { var show = formOut && !footerIn; bar.classList.toggle('is-visible', show); bar.setAttribute('aria-hidden', String(!show)); qsa('a, button', bar).forEach(function (b) { b.tabIndex = show ? 0 : -1; }); document.body.classList.toggle('has-sticky-atc', show); if (show) setH(); }
    new IntersectionObserver(function (en) { formOut = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; apply(); }).observe(form);
    if (footer) new IntersectionObserver(function (en) { footerIn = en[0].isIntersecting; apply(); }).observe(footer);
    function syncSwatch() { var sw = qs('[data-sticky-swatch]', bar), src = qs('[data-select-swatch]', sec) || qs('.swatch input:checked + label', sec); if (sw && src) sw.setAttribute('style', src.getAttribute('style') || ''); }
    syncSwatch();
    on(sec, 'variant:change', function (e) {
      var v = e.detail.variant;
      var name = qs('[data-sticky-variant]', bar); if (name) name.textContent = v.title;
      var sw = qs('[data-sticky-swatch]', bar), src = qs('[data-select-swatch]', sec) || qs('.swatch input:checked + label', sec);
      if (sw && src) sw.setAttribute('style', src.getAttribute('style') || '');
      var img = qs('.sticky-atc__img img', bar); if (img && v.image) { img.src = v.image; img.removeAttribute('srcset'); }
    });
  }

  /* Back in stock: show the notify form only for sold-out variants and tag the request with the variant */
  function initNotify(sec) {
    var box = qs('[data-notify]', sec); if (!box) return;
    on(sec, 'variant:change', function (e) {
      var v = e.detail.variant;
      if (!qs('.form-message--success', box)) box.hidden = !!v.available;
      var note = qs('[data-notify-note]', box); if (note) note.value = note.value.split(' – ')[0] + ' – ' + v.title;
      var tags = qs('[data-notify-tags]', box); if (tags) tags.value = tags.getAttribute('data-base-tags') + ',variant-' + v.id;
    });
  }

  /* Bundle: live total and add selected items in one /cart/add.js call */
  function initBundle(sec) {
    qsa('[data-bundle]', sec).forEach(function (b) {
      var total = qs('[data-bundle-total]', b), btn = qs('[data-bundle-add]', b), err = qs('[data-bundle-error]', b);
      var fmt = total && total.getAttribute('data-money-format');
      function sum() {
        var t = 0, n = 0;
        qsa('[data-bundle-check]', b).forEach(function (c) { if (c.checked) { t += parseInt(c.getAttribute('data-price'), 10) || 0; n++; } });
        if (total) total.textContent = C.formatMoney(t, fmt);
        if (btn) btn.disabled = n < 1;
      }
      on(b, 'change', sum);
      on(sec, 'variant:change', function (e) { var main = qs('[data-bundle-main]', b); if (main) { main.setAttribute('data-variant-id', e.detail.variant.id); main.setAttribute('data-price', e.detail.variant.cents); sum(); } });
      on(btn, 'click', function () {
        var items = qsa('[data-bundle-check]', b).filter(function (c) { return c.checked; }).map(function (c) { return { id: parseInt(c.getAttribute('data-variant-id'), 10), quantity: 1 }; });
        if (err) err.hidden = true;
        C.addToCart(items, btn).catch(function (e2) { if (err) { err.textContent = e2.message; err.hidden = false; } });
      });
      sum();
    });
  }

  function initComplementary(sec) {
    qsa('[data-complementary]', sec).forEach(function (box) {
      if (box.dataset.ready) return; box.dataset.ready = '1';
      C.fetchText(box.getAttribute('data-complementary')).then(function (html) {
        var fresh = qs('[data-complementary]', C.parseHTML(html));
        if (fresh && fresh.innerHTML.trim()) { box.innerHTML = fresh.innerHTML; C.initScope(box); }
      }).catch(function () {});
    });
  }

  C.register(function (scope) {
    qsa('[data-product-section]', scope).forEach(function (sec) {
      if (sec.dataset.pageReady) return; sec.dataset.pageReady = '1';
      initGallery(sec); initLightbox(sec); initStories(sec); initSticky(sec); initNotify(sec); initBundle(sec); initComplementary(sec);
    });
  });
})();
